import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import moment from 'moment';
import { Table, Pagination, Icon, Button, Grid ,Input} from 'semantic-ui-react';
import { updateStaff, getStaffs, getStaffById, sortStaffs, setActivePage, showLoading, hideLoading, openStaffModal } from '../actions';
import StaffDetails from './StaffDetails';

class Staffs extends Component {
    state = {
        column: null,
        data: [],
        length: 0,
        direction: null,
        page: 0,
        rowsPerPage: 15,
        addStaffModal: false,
        newStaff: {
            name: '',
            email: '',
            phone: '',
            role: '',
            address: {
                address_1: '',
                address_2: '',
                postcode: '',
                town_city: '',
                state: '',
                country: ''
            }
        }
    }

    constructor(props) {
        super(props);
        props.showLoading('Retrieving Staffs . . . ');
        props.getStaffs({});
    }

    componentDidMount() {
        this.props.setActivePage('staffs');
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.staff.list !== nextProps.staff.list) {
            console.log(nextProps.staff.list);
            this.setState({ data: _.chunk(nextProps.staff.list, this.state.rowsPerPage), length: nextProps.staff.list.length, column: nextProps.staff.sortColumn, direction: nextProps.staff.sortDirection, page: 0 });
            this.props.hideLoading();
        } else if ((this.props.staff.sortColumn !== nextProps.staff.sortColumn) || (this.props.staff.sortDirection !== nextProps.staff.sortDirection)) {
            this.setState({ data: _.chunk(nextProps.staff.list, this.state.rowsPerPage), column: nextProps.staff.sortColumn, direction: nextProps.staff.sortDirection, page: 0 });
        }
    }

    handleSort = (clickedColumn) => () => {
        this.props.sortStaffs(clickedColumn);
    }

    handleStaffSelect = (id, e) => {
        // e.preventDefault();
        this.props.getStaffById(id);
    }


    handleSearchChange = (e) => {
        var sValue = e.target.value;
        this.setState({ searchValue: sValue });
    }

    handleSearchSubmit = (e) => {
        if (e.keyCode !== 13) {
            return;
        }

        const re = new RegExp(_.escapeRegExp(e.target.value), 'i')
        const isMatch = result => (re.test(result.name) | re.test(result.email));

        let staff_list = _.filter(this.props.staff.list, isMatch);
        this.setState({ data: _.chunk(staff_list, this.state.rowsPerPage), length: staff_list.length });
    }

    handleRefresh = () => {
        this.props.showLoading('Retrieving Staffs . . . ');
        this.props.getStaffs({});
        console.log("Refresh List");
    }

    render() {
        const { data, page, column, direction, rowsPerPage, length,searchValue  } = this.state;

        return (
            <Fragment>
                <StaffDetails />
                <Grid>
                    <Grid.Column floated='left' width={14}>
                        <Input icon='search' placeholder='Search...' value={searchValue} onKeyUp={this.handleSearchSubmit} onChange={this.handleSearchChange} />
                    </Grid.Column>
                    <Grid.Column floated='right' width={1}>
                        <Button icon onClick={this.handleRefresh}><Icon name='refresh'/></Button>
                    </Grid.Column>
                </Grid>

                <Table sortable celled structured selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
                                Name
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Phone
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Email
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Role
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Last Login
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data[page] &&
                         (data.length > 0) ?
                            data[page].map((staff, index) => {
                                return (
                                    <Table.Row key={staff._id} onClick={this.handleStaffSelect.bind(this, staff._id)}>
                                        <Table.Cell>{staff.name}</Table.Cell>
                                        <Table.Cell><a href={'tel:' + staff.phone} onClick={(e) => e.stopPropagation()}>{staff.phone}</a></Table.Cell>
                                        <Table.Cell><a href={'mailto:' + staff.email} onClick={(e) => e.stopPropagation()}>{staff.email}</a></Table.Cell>
                                        <Table.Cell>{staff.role}</Table.Cell>
                                        <Table.Cell>{(staff.last_login) ? moment(staff.last_login).format('DD/MM/YYYY HH:mm') : 'Never'}</Table.Cell>
                                        <Table.Cell style={{ textAlign: 'center' }}><Icon name={staff.state === 'ACTIVE' ? 'check circle' : 'minus circle'} color={staff.state === 'ACTIVE' ? 'green' : 'red'}></Icon></Table.Cell>
                                    </Table.Row>)
                            }) :
                            <Table.Row>
                            <Table.Cell colSpan="6" textAlign="center">
                                No Record Found
                             </Table.Cell>
                        </Table.Row>
                        }
                    </Table.Body>
                </Table>
                <Pagination style={{ float: 'right' }} activePage={page + 1} totalPages={Math.ceil(length / rowsPerPage)} onPageChange={(e, data) => this.setState({ page: data.activePage - 1 })} />
            </Fragment>
        )
    }
}

const mapStateToProps = ({ staff }) => {
    return { staff }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateStaff: updateStaff,
        getStaffs: getStaffs,
        getStaffById: getStaffById,
        sortStaffs: sortStaffs,
        setActivePage: setActivePage,
        showLoading: showLoading,
        hideLoading: hideLoading,
        openStaffModal: openStaffModal
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Staffs);